import type { PackageLine, QuotePackage } from '@/components/quotes/PackageCard'
import { PricingKind, QuoteCardStage } from '@/components/quotes/quoteCardTypes'
import { CoverageType } from '@/models/insuranceCoverage'
import { QUOTES } from './quoteCardData'

/** Pulls one coverage off a prototype quote, so the package prices match the cards above it. */
function lineFrom(quoteId: string, type: CoverageType): PackageLine {
  const quote = QUOTES.find((candidate) => candidate.id === quoteId)
  const coverage =
    quote?.stage === QuoteCardStage.PRICED
      ? quote.coverages.find((candidate) => candidate.type === type)
      : undefined
  if (quote?.stage !== QuoteCardStage.PRICED || !coverage) {
    throw new Error(`No ${type} coverage on prototype quote ${quoteId}`)
  }
  const { carrierName, carrierProgram, sourcedThrough, iconUrl, iconAlt, pricingKind } = quote
  return { quoteId, carrierName, carrierProgram, sourcedThrough, iconUrl, iconAlt, pricingKind, coverage }
}

// The Palomar fixture prices auto liability only, so these lines are written out here.
const PALOMAR = {
  quoteId: 'palomar-via-rocklake',
  carrierName: 'Palomar',
  sourcedThrough: 'Rocklake',
  // The icon uploaded onto the Palomar carrier record in production.
  iconUrl: 'https://static.cai.insure/carrier_logos/46902c29-6bbc-485c-9ccd-fecf2294958d/palomar-icon.png',
  iconAlt: 'Palomar',
  pricingKind: PricingKind.INDICATION,
}

const LINES: PackageLine[] = [
  lineFrom('progressive', CoverageType.AUTO_LIABILITY),
  {
    ...PALOMAR,
    coverage: { type: CoverageType.MOTOR_TRUCK_CARGO, premium: 1900, limit: 100_000, deductible: 1000 },
  },
  {
    ...PALOMAR,
    coverage: { type: CoverageType.AUTO_PHYSICAL_DAMAGE, premium: 4500, limit: null, deductible: 2500 },
  },
]

export const PACKAGE: QuotePackage = {
  id: 'package-full-fleet',
  lines: LINES,
  // No fees and no one-sum carriers here, so the lines' premiums are what the cart would charge.
  total: LINES.reduce((sum, line) => sum + (line.coverage.premium ?? 0), 0),
}
